export default [
  {
    name: "Kindergarten",
    items: [
      {
        name: "K. Forces and Interactions: Pushes and Pulls",
        value: "",
      },
      {
        name: "K. Interdependent Relationships in Ecosystems: Animals, Plants, and Their Environment",
        value: "",
      },
      {
        name: "K. Weather and Climate",
        value: "",
      },
    ]
  },
  {
    name: "First Grade", items: [
      {
        name: "1. Waves: Light and Sound",
        value: "",
      },
      {
        name: "1. Structure, Function, and Information Processing",
        value: "",
      },
      {
        name: "1. Space Systems: Patterns and Cycles",
        value: "",
      },
    ]
  },
  {
    name: "Second Grade", items: [
      {
        name: "2. Structure and Properties of Matter",
        value: "",
      },
      {
        name: "2. Interdependent Relationships in Ecosystems",
        value: "",
      },
      {
        name: "2. Earth’s Systems: Processes That Shape the Earth",
        value: "",
      },
    ]
  },
  {
    name: "K–2 Engineering Design", items: [
      {
        name: "K-2. Engineering Design",
        value: "",
      },
    ]
  },
  {
    name: "Third Grade",
    items: [
      {
        name: "3. Forces and Interactions",
        value: "",
      },
      {
        name: "3. Interdependent Relationships in Ecosystems",
        value: "",
      },
      {
        name: "3. Inheritance and Variation of Traits: Life Cycles and Traits",
        value: "",
      },
      {
        name: "3. Weather and Climate",
        value: "",
      },
    ]
  },
  {
    name: "Fourth Grade",
    items: [
      {
        name: "4. Energy",
        value: "",
      },
      {
        name: "4. Waves: Waves and Information",
        value: "",
      },
      {
        name: "4. Structure, Function, and Information Processing",
        value: "",
      },
      {
        name: "4. Earth’s Systems: Processes That Shape the Earth",
        value: "",
      },
    ]
  },
  {
    name: "Fifth Grade", items: [
      {
        name: "5. Structure and Properties of Matter",
        value: "",
      },
      {
        name: "5. Matter and Energy in Organisms and Ecosystems",
        value: "",
      },
      {
        name: "5. Earth’s Systems",
        value: "",
      },
      {
        name: "5. Space Systems: Stars and the Solar System",
        value: "",
      },
    ]
  },
  {
    name: "3–5 Engineering Design", items: [
      {
        name: "3-5. Engineering Design",
        value: "",
      },
    ]
  },
  {
    name: "Middle School Physical Sciences", items: [
      {
        name: "MS. Structure and Properties of Matter",
        value: "",
      },
      {
        name: "MS. Chemical Reactions",
        value: "",
      },
      {
        name: "MS. Forces and Interactions",
        value: "",
      },
      {
        name: "MS. Energy",
        value: "",
      },
      {
        name: "MS. Waves and Electromagnetic Radiation",
        value: "",
      },
    ]
  },
  {
    name: "Middle School Life Sciences", items: [
      {
        name: "MS. Structure, Function, and Information Processing",
        value: "",
      },
      {
        name: "MS. Matter and Energy in Organisms and Ecosystems",
        value: "",
      },
      {
        name: "MS. Interdependent Relationships in Ecosystems",
        value: "",
      },
      {
        name: "MS. Growth, Development, and Reproduction of Organisms",
        value: "",
      },
      {
        name: "MS. Natural Selection and Adaptations",
        value: "",
      },
    ]
  },
  {
    name: "Middle School Earth and Space Sciences", items: [
      {
        name: "MS. Space Systems",
        value: "",
      },
      {
        name: "MS. History of Earth",
        value: "",
      },
      {
        name: "MS. Earth’s Systems",
        value: "",
      },
      {
        name: "MS. Weather and Climate",
        value: "",
      },
      {
        name: "MS. Human Impacts",
        value: "",
      },
    ]
  },
  {
    name: "Middle School Engineering Design", items: [
      {
        name: "MS. Engineering Design",
        value: "",
      },
    ]
  },
  {
    name: "High School Physical Sciences", items: [
      {
        name: "HS. Structure and Properties of Matter",
        value: "",
      },
      {
        name: "HS. Chemical Reactions",
        value: "",
      },
      {
        name: "HS. Forces and Interactions",
        value: "",
      },
      {
        name: "HS. Energy",
        value: "",
      },
      {
        name: "HS. Waves and Electromagnetic Radiation",
        value: "",
      },
    ]
  },
  {
    name: "High School Life Sciences", items: [
      {
        name: "HS. Structure and Function",
        value: "",
      },
      {
        name: "HS. Matter and Energy in Organisms and Ecosystems",
        value: "",
      },
      {
        name: "HS. Interdependent Relationships in Ecosystems",
        value: "",
      },
      {
        name: "HS. Inheritance and Variation of Traits",
        value: "",
      },
      {
        name: "HS. Natural Selection and Evolution",
        value: "",
      },
    ]
  },
  {
    name: "High School Earth and Space Sciences", items: [
      {
        name: "HS. Space Systems",
        value: "",
      },
      {
        name: "HS. History of Earth",
        value: "",
      },
      {
        name: "HS. Earth’s Systems",
        value: "",
      },
      {
        name: "HS. Weather and Climate",
        value: "",
      },
      {
        name: "HS. Human Sustainability",
        value: "",
      },
    ]
  },
  {
    name: "High School Engineering Design", items: [
      {
        name: "HS. Engineering Design",
        value: "",
      },
    ]
  },
]



// WEBPACK FOOTER //
// ./src/constants/standards.js